import { WiseOwlIngress } from "@twiliointernal/e2-commons-shared-definitions";

export interface LiveChatPreEngagementFormValues {
  product: string;
  message: string;
}

export enum LiveChatPreEngagementFormFields {
  Product = "product",
  Message = "message",
}

export interface LiveChatPreEngagementProps {
  selectedProductCategory?: string;
  message?: string;
  handleStartEngagement: (
    productCategory: string,
    message: string
  ) => Promise<void>;
  handleToggleVisibility: () => void;
  isOpen?: boolean;
  ingress: WiseOwlIngress;
}
